import { styled } from '@mui/material'
import { createGlobalStyle } from 'styled-components'

export const GlobalStyle = createGlobalStyle`
  .highcharts-credits,
  .highcharts-legend-item {
    display: none !important;
  }
`

export const Root = styled('div')`
  width: 100%;
`
